import { useQuery } from '@tanstack/react-query';
import { normalizeFacesheetOutput } from '../components/patient-profile/facesheet-viewer/facesheetOutputNormalizer';
import { trpc } from '@/utils/trpc';

export interface GetFacesheetSummaryParams {
  patientId: string;
  facesheetRequestId: string;
}

export interface GetFacesheetReferenceDetailParams {
  patientId: string;
  facesheetRequestId: string;
  referenceId: string;
  includeContext?: boolean;
}

export const useGetFacesheetSummary = (
  params: GetFacesheetSummaryParams | undefined,
) =>
  useQuery({
    ...trpc.patientsRouter.getPatientFacesheetOutput.queryOptions({
      patientId: params?.patientId ?? '',
      facesheetRequestId: params?.facesheetRequestId ?? '',
    }),
    enabled: Boolean(params?.patientId && params?.facesheetRequestId),
    select: normalizeFacesheetOutput,
  });

export const useGetFacesheetReferenceDetail = (
  params: GetFacesheetReferenceDetailParams | undefined,
) =>
  useQuery({
    ...trpc.patientsRouter.getPatientFacesheetReferenceDetail.queryOptions({
      patientId: params?.patientId ?? '',
      facesheetRequestId: params?.facesheetRequestId ?? '',
      referenceId: params?.referenceId ?? '',
      includeContext: params?.includeContext ?? true,
    }),
    enabled: Boolean(
      params?.patientId && params?.facesheetRequestId && params?.referenceId,
    ),
  });
